//* External
import PropTypes from 'prop-types';

//* App Custom
import { CustomIcon } from '@componentsApp/common/index';
import { tnl } from '@i18nApp/i18n';
import { debounce } from 'lodash';
import InputLabel from '../InputLabel/InputLabel';
import '../inputs.scss';

const InputTextArea = ({
  name,
  label,
  labelHelper,
  placeholder,
  iconName,
  defaultValue,
  disabled = false,
  required = false,
  design = 'col-12',
  hookError,
  hookOnChange = () => {},
  onInputChange = () => {},
  onFocus = () => {},
  onBlur = () => {}
}) => {
  const debouncedSetValue = debounce((value) => {
    hookOnChange(value);
    onInputChange(value);
  }, 500);

  return (
    <div className={design}>
      <div
        className={`customInput customInput_textArea ${
          disabled ? 'customInput_disabled' : ''
        }`}
      >
        {label && (
          <InputLabel
            name={name}
            text={label}
            helper={labelHelper}
            required={required}
          />
        )}
        <div className="customInput_container">
          {iconName && (
            <CustomIcon
              className="customInput_icon"
              name={iconName}
              color="gray"
            />
          )}
          <textarea
            rows={4}
            id={name}
            placeholder={tnl(placeholder)}
            disabled={disabled}
            defaultValue={defaultValue}
            onChange={(e) => {
              const value = e.target.value;
              debouncedSetValue(value);
            }}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </div>
        {hookError?.message && (
          <p className="customInput_error">{tnl(hookError?.message)}</p>
        )}
      </div>
    </div>
  );
};

InputTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  iconName: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  design: PropTypes.string,
  hookError: PropTypes.shape({
    message: PropTypes.string
  }),
  hookOnChange: PropTypes.func,
  onInputChange: PropTypes.func
};

export default InputTextArea;
